// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__23ECm","title":"BackImages_title__1EvMz","images":"BackImages_images__1sDsU"};